import React, {useEffect, useRef, useState} from 'react';
import {Button} from 'primereact/button';
import {useTranslation} from 'react-i18next';
import '../../style/file-management.scss';
import {Image} from 'primereact/image';
import {CustomConfirmDialog} from './CustomConfirmDialog';
import {deleteFile, getFiles, insertFile} from '../functions/Global';
import {showMessageOnError, showMessageOnSuccess} from './CustomToast';
import {hideWaitAnimation, showWaitAnimation} from './CustomWaitAnimation';
import {Tooltip} from "primereact/tooltip";
import {ProgressBar} from "primereact/progressbar";
import {useAppSelector} from "../../redux/hooks";
import {classNames} from "primereact/utils";


type Props = {}


const UploadProgress = (props: Props) => {
    const {t} = useTranslation(['common']);

    const status = useAppSelector((state: any) => state.importData);
    const uploadRef = useRef<any>(null);
    const [started, setStarted] = useState<boolean>(false);
    const [startedClass, setStartedClass] = useState<string>('begin');
    const [percentage, setPercentage] = useState<number>(0);

    useEffect(() => {
        setStarted(status.uploadTotal > 0);

        let tempPercentage = (status.uploadCount / status.uploadTotal * 100) / 2;

        if (status.uploadStep === '2/2') {
            tempPercentage += 50;
        }

        setPercentage(tempPercentage);
    }, [status]);

    useEffect(() => {
        console.log('%', percentage)
    }, [percentage]);

    useEffect(() => {
        if (started) {
            // console.log('upload started');
            setTimeout(() => {
                setStartedClass('started')
            }, 2000);
        }
    }, [started]);

    const getStatusTooltip = () => {
        return percentage.toFixed(0) + '%\n' +
            t('step') + ': ' + status.uploadStep + '\n' +
            status.uploadCount + '/' + status.uploadTotal + '\n' +
            status.uploadType
    }

    return (<>{started &&
        <div ref={uploadRef} className={classNames('upload-status card', startedClass)}
             style={{left: uploadRef.current && startedClass !== 'started' ? (window.innerWidth / 2) - (uploadRef.current.clientWidth / 2) : undefined}}>
            <ul className={"layout-inline-menu-action-panel absolute"}
                style={{left: '2px', bottom: '3px'}}>
                <li className="layout-inline-menu-action-item -mb-1" style={{cursor: 'default'}}>
                    <div>
                        <Tooltip target=".statusTooltip" position={'top'}/>
                        <button className="p-link statusTooltip"
                                style={{paddingLeft: '12px'}}
                                data-pr-tooltip={getStatusTooltip()}>
                            <i className="pi pi-cloud-upload"></i>
                            <ProgressBar value={percentage} color={'green'}
                                         showValue={false}
                                         className={'w-full'}/>
                        </button>
                    </div>
                </li>
            </ul>
        </div>}</>
    );
};

export default UploadProgress;
